import { Phone } from "lucide-react";
import { SITE } from "../data/site";
import { useOrder } from "./OrderDialog";
import { useLang } from "../i18n";

export const MobileCTA = () => {
    const order = useOrder();
    const { t } = useLang();
    return (
        <div
            data-testid="mobile-bottom-bar"
            className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-ink/90 backdrop-blur-xl border-t border-brass/20 px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
        >
            <div className="flex gap-3">
                <a
                    data-testid="mobile-bottom-call-button"
                    href={SITE.phoneHref}
                    className="flex-1 inline-flex items-center justify-center gap-2 rounded-full gold-border py-3.5 text-xs font-semibold tracking-[0.12em] text-cream"
                >
                    <Phone className="w-4 h-4 text-saffron-bright" /> {t("misc.call")}
                </a>
                <button
                    data-testid="mobile-bottom-order-cta"
                    onClick={() => order?.openOrder()}
                    className="flex-[1.6] rounded-full bg-saffron py-3.5 text-xs font-semibold tracking-[0.12em] text-ink"
                >
                    {t("misc.orderOnline")}
                </button>
            </div>
        </div>
    );
};
